module.exports = __webpack_public_path__ + "img/productVibration_2.5e996bb4.png";